import * as React from 'react';

import { cn } from '@/lib/utils';

import { Container } from './Container.tsx';
import { SECTION_BACKGROUNDS, SECTION_VERTICAL_PADDING } from './tokens.ts';

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  padding?: keyof typeof SECTION_VERTICAL_PADDING;
  background?: keyof typeof SECTION_BACKGROUNDS;
  withContainer?: boolean;
  containerProps?: React.ComponentProps<typeof Container>;
}

const Section = React.forwardRef<HTMLElement, SectionProps>(
  (
    {
      as: Component = 'section',
      padding = 'lg',
      background = 'default',
      withContainer = true,
      containerProps,
      className,
      children,
      ...props
    },
    ref
  ) => {
    const content = withContainer ? (
      <Container {...containerProps}>{children}</Container>
    ) : (
      children
    );

    return (
      <Component
        ref={ref}
        className={cn(
          SECTION_VERTICAL_PADDING[padding],
          SECTION_BACKGROUNDS[background],
          className
        )}
        {...props}
      >
        {content}
      </Component>
    );
  }
);
Section.displayName = 'Section';

export { Section };
